import type { Person } from "features/people/data/types";
import React, { useMemo } from "react";
import "./PersonBubble.css";

type OwnProps = {
  person: Person;
  moderationMode?: boolean;
  showEditLink?: boolean;
};

const PersonBubble: React.FC<OwnProps> = ({
  person,
  moderationMode = false,
  showEditLink = false,
}) => {
  const fullName = useMemo(
    () => [person.firstName, person.secondName].filter(Boolean).join(" "),
    [person.firstName, person.secondName],
  );

  const hasRating = person.engagementScore !== undefined;

  return (
    <div className="person-bubble">
      <img
        className="person-bubble__avatar"
        src={
          person.avatarUrl || "https://randomuser.me/api/portraits/lego/1.jpg"
        }
        alt={fullName || `Person ${person.id}`}
      />

      <div className="person-bubble__main">
        <div className="person-bubble__name">
          <a href={`/#/people/${person.id}/`}>
            {fullName || `Person ${person.id}`}
          </a>
        </div>

        {hasRating && (
          <div className="person-bubble__rating">
            <span title="Engagement">E:{person.engagementScore}</span>
            <span title="Authority">A:{person.authorityScore}</span>
            <span title="Learning">L:{person.learningScore}</span>
            <span
              className="person-bubble__rating-sum"
              title="Рейтинг (черновой, A+E)"
            >
              Σ:{person.ratingSum}
            </span>
          </div>
        )}

        {moderationMode && person.moderationReason ? (
          <div className="person-bubble__reason">
            Причина: {person.moderationReason}
          </div>
        ) : null}
      </div>

      {showEditLink ? (
        <a
          className="person-bubble__edit"
          href={`/#/people/${person.id}/edit`}
        >
          edit
        </a>
      ) : null}
    </div>
  );
};

export default PersonBubble;
